import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/resourcesList/resource/styles.scss';export default {
  "resource": "_resource_1axet_1",
  "icon": "_icon_1axet_26",
  "removeResourceIconContainer": "_removeResourceIconContainer_1axet_38"
};